export default class LoaderService {
    anchor;
    input;
    downloadFile(url, fileName) {
        this.anchor = document.createElement('a');
        this.anchor.href = url;
        this.anchor.download = fileName;
        this.anchor.click();
        delete this.anchor;
    }
    uploadFile() {
        return new Promise((resolve) => {
            this.input = document.createElement('input');
            this.input.type = 'file';
            this.input.accept = '.json';
            this.input.addEventListener('change', (event) => this.handleUploadedFile.bind(this)(event, resolve), { once: true });
            this.input.click();
        });
    }
    handleUploadedFile(event, resolve) {
        const input = event.target;
        if (input instanceof HTMLInputElement && input.files) {
            const optionsFile = input.files.item(0);
            resolve(optionsFile);
        }
        delete this.input;
    }
}
